import { createRouter, createWebHashHistory } from "vue-router";
const router = createRouter({
  history: createWebHashHistory(),

  routes: [
    {
      path: '/',
      component: () => import('../views/home/Home')
    },
    {
      path: '/mine',
      component: () => import('../views/mine/Mine')
    },
    {
      path: '/leave',
      component: () => import('../views/leave/Leave')
    },
    {
      path: '/leaverecord',
      component: () => import('../views/leave/LeaveRecord')
    },{
      path: '/baseinfo',
      component: () => import('../views/Info/BaseInfo')
    },
    {
      path: '/baseinfoedit',
      component: () => import('../views/Info/BaseInfoEdit')
    },
    {
      path: '/rewardinfo',
      component: () => import('../views/Info/RewardInfo')
    },
    {
      path: '/rewardinfoedit',
      component: () => import('../views/Info/RewardInfoEdit')
    },
    {
      path: '/stayinfo',
      component: () => import('../views/Info/StayInfo')
    },
    {
      path: '/stayinfoedit',
      component: () => import('../views/Info/StayInfoEdit')
    },
    {
      path: '/stayquestion',
      component: () => import('../views/Info/StayQuestion')
    },
    {
      path: '/gradeinfo',
      component: () => import('../views/Info/GradeInfo')
    },
    {
      path: '/noticelist',
      component: () => import('../views/notice/NoticeList')
    },
    {
      path: '/noticedetail',
      component: () => import('../views/notice/NoticeDetail')
    },
    {
      path: '/newslist',
      component: () => import('../views/news/NewsList')
    },
    {
      path: '/newsdetail',
      component: () => import('../views/news/NewsDetail')
    },
    {
      path: '/upload',
      component: () => import('../views/news/Upload.vue')
    }
  ],
  linkActiveClass: 'active', // 设置自定义的活动类名

})
export default router